import { SvgIcon, useTheme } from "@mui/material";
import type React from "react";
import { useState } from "react";
import { tileTextStyle } from "./style.ts";

const Locomotives: React.FC<{ selected: boolean }> = ({ selected }) => {
	const [hovered, setHovered] = useState(false);
	const theme = useTheme();
	const idleBackground = theme.palette.secondary.main;
	const hoverBackground = theme.palette.secondary.light;
	const selectedBackGround = theme.palette.info.main;

	const backGroundColor = selected ? selectedBackGround : hovered ? hoverBackground : idleBackground;
	return (
		<SvgIcon
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
			viewBox="0 0 460 259"
			sx={{ width: "100%", height: "auto" }}
		>
			<defs>
				<style>{".cls-2{stroke-miterlimit:10;fill:none;stroke:#fff}"}</style>
			</defs>
			<g id="pozadi-boxu">
				<path
					id="pozadi"
					d="M0 0h460v259H0z"
					style={{
						fill: backGroundColor,
					}}
				/>
			</g>
			<g id="ilustrace">
				<path
					id="Vrstva_2"
					d="M460 237.2H0"
					style={{
						stroke: "#fff",
						fill: "none",
					}}
				/>
				<g
					id="pozemky"
					style={{
						clipPath: "url(#clip-path)",
					}}
				>
					<path
						d="M149.9 212.2H147v2.7h-21.9l-2.7 2.2v9.6M149.9 212.2h2.9v2.7h21.9l2.7 2.2v9.6M139.4 231.1h21M275.7 174.7v-10h20.6v16.6l27.3 8.1v-33.3H434l4.8 26.7-3.6 23.1v9.4l-9.7-3.3H275.7v-6.1"
						className="cls-2"
					/>
					<path d="M84.6 205.9h18.6v-49.8l2.5-3.2h326.6l1.7 3.2" className="cls-2" />
					<path
						d="m352.3 212.1-99.2-28.9h-69.5c-3.3 0-6.2 1.9-7.7 4.8l-6.3 15.9v8.2h-57.9v7.7H99.5M103.2 205.9h42.2"
						className="cls-2"
					/>
					<path d="M330.9 205.9h-55.2v-16" className="cls-2" />
					<path
						d="M435.3 205.9h-57l-54.6-16.6-27.3-8.1-41.1-13.3h-79.8c-2.7 0-5.3 1.3-6.8 3.6l-23.1 34.3v6.3M323.6 156.1H103.2M103.2 184.7H84.6M99.5 205.9v20.6H84.6v-46M99.5 219.9H84.6M99.5 226.5H84.6M99.5 213.3H84.6"
						className="cls-2"
					/>
					<path
						d="M394.4 205.9v6.1h-16.2v-6.1M298.4 181.9l4-2.2h92M378.2 156.1v49.7M394.4 156.1v49.8M333.4 156.1v36.2M323.6 166.7h54.6M344.6 166.7v29M355.8 166.7V199M367 166.7v35.7M349.4 166.7v-10.6M115 231.1h8.5M418.8 231.1h-6M404.5 231.1h-10.1M418.8 231.1h6.3v3.5h-6.3zM368.4 212l-1.9 8.7 3.1 10.4h5.8M398.4 212l1.9 8.7-3.1 10.4h-5.9M290 156.1v8.6M281.9 156.1v8.6M243.6 156.1V168M223.7 156.1V168M181.3 156.1V168M250.6 152.9v-5.1M271.6 152.9v-5.1M246.4 147.8h29.4M321.5 152.9v-5.1M344.9 152.9v-5.1M368.4 152.9v-5.1M317.3 147.8h55.6M270.4 156.1l-2.4 6h-6.9M251.7 156.1l2.4 6h7M259.2 162.1h3.7v3.7h-3.7zM416.3 212v19M404.5 212v19.1M348.1 229.7l8.2-3V212H354M344.6 227.4V212M320.2 212.2v14.1M265.7 230h54.5v-3.7M320.2 226.3h-54.5"
						className="cls-2"
					/>
					<circle cx={191.8} cy={193.8} r={2.7} className="cls-2" />
					<path d="m198.6 228.4.4-7h2l-.8 10.2-1.6-3.2z" className="cls-2" />
					<circle cx={223.9} cy={193.8} r={2.7} className="cls-2" />
					<path
						d="m217.1 228.4-.4-7h-1.9l.7 10.2 1.6-3.2zM188.4 183.2l.7 7.4-1.6 1.5 3.1 26 3.3 11.3h3l-1.8-8.5v-11M227.5 183.2l-.7 7.4 1.6 1.5-3.2 26-3.2 11.3h-3l1.8-8.5v-11M195.6 183.2l-.7 6.7h25.8l-.5-6.7M201.9 216.5s.4-1 5.9-1 6 1 6 1"
						className="cls-2"
					/>
					<path
						d="m200.7 211.7 4.1-1.6v-9.5h-2.4v-4.5H197l-2.4 8.9 7.6 8.2-.7 8.2h-3.7l.5-6.5-6.5-9.5v-8.9M214.8 211.7l-4.1-1.6v-9.5h2.4v-4.5h5.6l2.5 8.9-7.7 8.2.8 8.2h3.6l-.5-6.5 6.5-9.5v-8.9M135.8 234.7c2.8-1.5 4.7-4.5 4.7-7.9 0-5-4.1-9.1-9.1-9.1s-9.1 4.1-9.1 9.1 1.9 6.4 4.7 7.9M127.1 234.7c1.3.7 2.8 1.1 4.4 1.1s3.1-.4 4.4-1.1M172.7 234.7c2.8-1.5 4.7-4.5 4.7-7.9 0-5-4.1-9.1-9.1-9.1s-9.1 4.1-9.1 9.1 1.9 6.4 4.7 7.9M164 234.7c1.3.7 2.8 1.1 4.4 1.1s3.1-.4 4.4-1.1M387.7 234.7c2.8-1.5 4.7-4.5 4.7-7.9 0-5-4.1-9.1-9.1-9.1s-9.1 4.1-9.1 9.1 1.9 6.4 4.7 7.9M379 234.7c1.3.7 2.8 1.1 4.4 1.1s3.1-.4 4.4-1.1M347.2 234.7c.8-.8 1.3-1.8 1.3-3 0-2.3-1.9-4.2-4.2-4.2s-4.2 1.9-4.2 4.2.5 2.3 1.3 3M341.6 234.7c.7.7 1.7 1.1 2.8 1.1s2.1-.4 2.8-1.1M235.9 234.7c.8-.8 1.3-1.8 1.3-3 0-2.3-1.9-4.2-4.2-4.2s-4.2 1.9-4.2 4.2.5 2.3 1.3 3M230.3 234.7c.7.7 1.7 1.1 2.8 1.1s2.1-.4 2.8-1.1M113.7 234.7c.8-.8 1.3-1.8 1.3-3 0-2.3-1.9-4.2-4.2-4.2s-4.2 1.9-4.2 4.2.5 2.3 1.3 3M108 234.7c.7.7 1.7 1.1 2.8 1.1s2.1-.4 2.8-1.1M405.8 234.7c.7.7 1.7 1.1 2.8 1.1s2.1-.4 2.8-1.1M411.5 234.7c.8-.8 1.3-1.8 1.3-3 0-2.3-1.9-4.2-4.2-4.2s-4.2 1.9-4.2 4.2.5 2.3 1.3 3M259.2 234.7V230h2.7v4.7M259.2 234.7v5.4h2.7v-5.4M253 183.2v14.3h3.9v-13.1M255 217.7v-20.2M253 183.2l-16.4 22.7"
						className="cls-2"
					/>
					<path
						d="M236.6 229.4v-46.2h2M275.7 212v14.3M265.7 230v-12.3h-12.3V230h12.3M111.7 219.9v7.5M306.7 226.3V212"
						className="cls-2"
					/>
					<rect width={25} height={14.7} x={112.6} y={164.6} className="cls-2" rx={2.2} ry={2.2} />
					<path
						d="M431.9 178.4c.3 1.2-.5 2.2-1.7 2.2h-24.4c-1.2 0-2.2-1-2.2-2.2v-12.7c0-1.2 1-2.2 2.2-2.2h20.6c1.2 0 2.4 1 2.7 2.2l2.9 12.8Z"
						className="cls-2"
					/>
				</g>
			</g>
			<text
				id="texty"
        style={tileTextStyle}
				transform="translate(20 44.289)"
			>
				Kolejová vozidla
			</text>
		</SvgIcon>
	);
};

export default Locomotives;
